module.exports = __webpack_public_path__ + "static/media/slide-2.9b42efa8.webp";